import { Box, Button } from '@mui/material'

type Props = {
  onClickCancel?: false | (() => void)
}

const SaveCancelFormActions = (props: Props) => {
  return (
    <Box textAlign='right'>
      {props.onClickCancel && (
        <Button
          color='primary'
          onClick={() => props.onClickCancel && props.onClickCancel()}
        >
          cancel
        </Button>
      )}
      <Box display='inline' ml={2}>
        <Button color='primary' variant='contained' type='submit'>
          save
        </Button>
      </Box>
    </Box>
  )
}

export default SaveCancelFormActions
